<template>
  <div class="nav-bar" ref="navbar">
    <div class="left" @click="clickLeft" slot="leftImg">
      <van-icon name="arrow-left" :color="backColor" />
    </div>
    <div :style="'color:' + color + ';' + 'font-size:15px;'">{{ title }}</div>
    <div class="right">
      <van-icon v-if="isShare" size="24" name="share" @click="share"></van-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-bar",
  components: {},
  props: {
    scroll: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isShare: {
      type: Boolean,
      default() {
        return false;
      },
    },
    title: {
      type: String,
      default() {
        return "";
      },
    },
    color: {
      type: String,
      default() {
        return "#fff";
      },
    },
  },
  data() {
    return {
      backColor: "#fff",
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", this.watchScroll);
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      if (!this.scroll) {
        return;
      }
      let h = document.documentElement.scrollTop || document.body.scrollTop;
      let headerTop = this.$refs.navbar;
      let color = 255 - h * 1.275;
      let s = h * 0.01;
      // console.log(s)
      // console.log(color)
      this.backColor = `rgb(${color},${color},${color})`;
      // headerTop.style.color =
      headerTop.style.background = `rgba(255,255,255,${s})`;
    },
    // 点击左侧返回
    clickLeft() {
      if (this.$router.go(-1) === undefined) {
        this.$router.push({
          path: "/",
        });
      }
    },
    // 点击爱心收藏
    like() {
      this.$emit("like");
    },
    // 点击分享
    share() {
      this.$emit("share");
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-bar {
  // z-index: 1;
  height: 46px;
  color: #fff;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  justify-content: space-between;
  align-items: center;
  // position: fixed;
  // top: 0;
  // left: 0;
  // right: 0;
  padding: 0 16px;

  .left {
    width: 50px;
  }

  .right {
    width: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span.active {
      color: #ff6d55;
    }
  }
}
</style>
